// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"217":"forum/components/DraftsPage","399":"forum/components/DraftsDropdown","519":"forum/components/ScheduleDraftModal"}[chunkId] + ".js";
};